import React, { ErrorInfo } from "react";
import APIFailurePopup from "./components/CustomAPIFailurePopup/APIFailurePopup";
interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
  errorInfo: ErrorInfo | null;
}
class ErrorBoundary extends React.Component<Props, State> {
  // Constructor for initializing Variables etc in a state
  // Just similar to initial line of useState if you are familiar
  // with Functional Components
  constructor(props: Props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  retryPageLoading = () => {
    console.log("in retryPageLoading fn");
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem("PageHasBeenForceRefreshed") || "false"
    ) as boolean;

    if (!pageHasAlreadyBeenForceRefreshed) {
      window.localStorage.setItem("PageHasBeenForceRefreshed", "true");
      return window.location.reload();
    } else {
      window.localStorage.setItem("PageHasBeenForceRefreshed", "false");
    }
  };

  clearError = () => {
    this.setState({ error: null, errorInfo: null });
  };

  // This method is called if any error is encountered
  async componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Catch errors in any components below and
    // re-render with error message
    const chunkFailedMsg = /Loading chunk .*failed.*[.js\\)]/;
    const chunkRefuseToExecuteFailedMsg = /Refused to execute/;
    console.log("in Error Boundary");
    console.log("err msg: ", error.message);
    console.log(
      "test msg",
      chunkFailedMsg.test(error.message) ||
        chunkRefuseToExecuteFailedMsg.test(error.message)
    );

    if (
      chunkFailedMsg.test(error.message) ||
      chunkRefuseToExecuteFailedMsg.test(error.message)
    ) {
      console.log("clearing cache");
      await Promise.all((await caches.keys()).map(caches.delete));
      console.log("cache cleared");
      this.retryPageLoading();
    }

    // You can also log error messages to an error
    // reporting service here
  }

  static getDerivedStateFromError(error: Error) {
    return {
      error: error,
      errorInfo: null,
    };
  }

  handleOpen = () => {
    this.clearError();
  };

  // This will render this component wherever called
  render() {
    return (
      <>
        {this.state.error ? (
          <APIFailurePopup open={true} handleOpen={this.handleOpen} />
        ) : (
          this.props.children
        )}
      </>
    );
  }
}
export default ErrorBoundary;
